import React from 'react';

import Chip from '~/components/core/Atomic/Chip/Chip';
import { prettifyKey } from '~/Utils';
import cn from '~/Utils/cn';

import ExpandingCard, { TONES } from './ExpandingCard';

export const CONFLICT_VIEW_VARIANT = {
  STACKED: 'STACKED',
  SIDE_BY_SIDE: 'SIDE_BY_SIDE',
} as const;

interface ConflictCardBaseProps {
  title: string;
  chipLabel?: string;
  isResolved: boolean;
  configurationType: string;
  summary: React.ReactNode;
  conflictViewVariant?: (typeof CONFLICT_VIEW_VARIANT)[keyof typeof CONFLICT_VIEW_VARIANT];
  conflictView: React.ReactNode;
}

const ConflictCardBase = ({
  title,
  chipLabel,
  isResolved,
  configurationType,
  summary,
  conflictViewVariant = CONFLICT_VIEW_VARIANT.STACKED,
  conflictView,
}: ConflictCardBaseProps) => {
  const cardTitle = <CardTitle title={title} chipLabel={chipLabel} />;
  return (
    <ExpandingCard title={cardTitle} label={title} tone={isResolved ? TONES.TEAL : TONES.PINK}>
      <div className="grid gap-16">
        <div className="text-slate-800">in {prettifyKey(configurationType)}</div>
        {summary}
        <div className="font-bold">Choose which version wins</div>
        <div
          role="radiogroup"
          aria-label={`${title} resolution`}
          className={cn('grid gap-8', { 'grid-cols-2': conflictViewVariant === CONFLICT_VIEW_VARIANT.SIDE_BY_SIDE })}
        >
          {conflictView}
        </div>
      </div>
    </ExpandingCard>
  );
};

const CardTitle = ({ title, chipLabel }: { title: string; chipLabel?: string }) => {
  return (
    <div className="flex items-center gap-12 text-lg font-medium">
      <span className="flex-1">{title}</span>
      {chipLabel ? <Chip size="small" label={chipLabel} color="default" /> : null}
    </div>
  );
};

export default ConflictCardBase;
